import { render } from "./petitionComponent.vue?vue&type=template&id=aa573b66"
import script from "./petitionComponent.vue?vue&type=script&lang=js"
export * from "./petitionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__